import { styled } from '@mui/material/styles';
export const Wrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    [theme.breakpoints.down('md')]: {
        alignItems: 'center',
    },
}));
export const Heading = styled('p')(({ theme }) => ({
    marginTop: 0,
    marginBottom: theme.spacing(2.5),
    fontSize: theme.typography.body1.fontSize,
    lineHeight: 1.53,
    userSelect: 'none',
    [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(2.5),
    },
}));
export const Container = styled('div')(() => ({
    display: 'flex',
    alignItems: 'flex-end',
}));
export const Icon = styled('a')(({ theme }) => ({
    fontSize: 0,
    '&:not(:last-child)': {
        marginRight: theme.spacing(2),
    },
}));
//# sourceMappingURL=styles.js.map